import { useRoute } from '@/data/hooks';
import { NS_FOOTER, NS_QUOTATION } from '@/i18n/namespaces';
import PIDMImage from '@images/PIDM.png';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from '../common';

type FooterProps = {
  showHelpAndPidm?: boolean;
  affiliateInfo?: {
    agentCode: string;
    agentBranch: string;
  };
};

export const Footer = ({ showHelpAndPidm, affiliateInfo }: FooterProps) => {
  const { t } = useTranslation([NS_FOOTER, NS_QUOTATION]);
  const { entity } = useRoute();

  return (
    <footer className="mb-6 flex flex-col">
      {showHelpAndPidm && (
        <div className="mb-6 border-y border-[#E1E1E1] py-6">
          <div className="pb-3 text-center text-base font-bold leading-5">
            {t('needHelp')}
          </div>
          <div className="text-center text-sm">
            <Trans
              ns={NS_FOOTER}
              i18nKey={'contactCustomerService'}
              components={{
                a: (
                  <a
                    className="font-semibold text-link underline underline-offset-4"
                    href="#"
                    target="_blank"
                  />
                ),
                b: (
                  <a
                    className="font-semibold text-link underline underline-offset-4"
                    href="#"
                    target="_blank"
                  />
                ),
              }}
            />
          </div>
        </div>
      )}

      {showHelpAndPidm && affiliateInfo && (
        <div className="container mx-auto mb-6 px-4 text-left text-sm text-[#707070]">
          {t('affiliate.agentCode', { ns: NS_QUOTATION })}:{' '}
          {affiliateInfo.agentCode} |{' '}
          {t('affiliate.agentBranch', { ns: NS_QUOTATION })}:{' '}
          {affiliateInfo.agentBranch}
        </div>
      )}

      <div className="flex flex-col">
        {showHelpAndPidm && (
          <div className="flex flex-col pb-6">
            <div className="self-center">
              <img className="object-none" alt="pidm-image" src={PIDMImage} />
            </div>
            <div className="text-center text-base text-[#707070]">
              <span className="whitespace-pre-line">
                <Trans
                  ns={NS_FOOTER}
                  i18nKey={`${entity}.benefitPayable`}
                  components={{
                    a: (
                      <Link
                        className="text-sm font-bold no-underline"
                        href={t('pidmTipsBrochureUrl')}
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                    b: (
                      <Link
                        className="text-sm font-bold no-underline"
                        href={t('pidmPortalUrl')}
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </span>
            </div>
          </div>
        )}
        <div className="text-center text-base text-[#707070]">
          {t(`${entity}.underwrittenByEtiqa`)}
        </div>
        <div className="text-center text-sm text-[#707070]">
          {t('licensed')}
        </div>
      </div>
    </footer>
  );
};
